import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../Card32/styles.module.css";
import GameScreen from "./GameScreen";
import FooterLinks from "../FooterLinks";
import { useLocation } from "react-router-dom";
import FlipClock from "../../FlipClock/FlipClock";
import useRoundLoader from "../../../api/useRoundLoader";

import useCasinoBetplace from "../../../api/useCasinoBetplace";

const SELECTIONS = {
  PLAYER8_ODD: "PLAYER8_ODD",
  PLAYER8_EVEN: "PLAYER8_EVEN",
  PLAYER9_ODD: "PLAYER9_ODD",
  PLAYER9_EVEN: "PLAYER9_EVEN",
  PLAYER10_ODD: "PLAYER10_ODD",
  PLAYER10_EVEN: "PLAYER10_EVEN",
  PLAYER11_ODD: "PLAYER11_ODD",
  PLAYER11_EVEN: "PLAYER11_EVEN",
};

const FirstRows = [
  {
    label: "Player 8",
    values: ["12.2", "13.7"],
    selections: ["PLAYER8", "PLAYER8"],
  },
  {
    label: "Player 9",
    values: ["5.95", "6.45"],
    selections: ["PLAYER9", "PLAYER9"],
  },
  {
    label: "Player 10",
    values: ["3.2", "3.45"],
    selections: ["PLAYER10", "PLAYER10"],
  },
  {
    label: "Player 11",
    values: ["2.08", "2.18"],
    selections: ["PLAYER11", "PLAYER11"],
  },
];

const SecondRows = [
  {
    label: "Player 8",
    values: ["1.97", "1.97"],
    selections: [SELECTIONS.PLAYER8_ODD, SELECTIONS.PLAYER8_EVEN],
  },
  {
    label: "Player 9",
    values: ["1.97", "1.97"],
    selections: [SELECTIONS.PLAYER9_ODD, SELECTIONS.PLAYER9_EVEN],
  },
  {
    label: "Player 10",
    values: ["1.97", "1.97"],
    selections: [SELECTIONS.PLAYER10_ODD, SELECTIONS.PLAYER10_EVEN],
  },
  {
    label: "Player 11",
    values: ["1.97", "1.97"],
    selections: [SELECTIONS.PLAYER11_ODD, SELECTIONS.PLAYER11_EVEN],
  },
];

function Card32({
  onBetSelect,
  locked,
  socketData,
  settledData,
  casinoBets = [],
  gameId,
  hookExposureData,
}) {
  const [betDialogOpen, setBetDialogOpen] = useState(false);
  const [selectedBet, setSelectedBet] = useState(null);
  const roundId = socketData?.roundId;

const [animTimer, setAnimTimer] = useState(null);
  const [exposureData, setExposureData] = useState(null);

useEffect(() => {
    if (hookExposureData === null) {
        setExposureData(null);
        return;
    }
    if (hookExposureData && hookExposureData.gameId === gameId) {
        setExposureData(hookExposureData);
    }
}, [hookExposureData, gameId]);
useEffect(() => {
  if (roundId) {
    setExposureData(null);
  }
}, [roundId]);

  const ExpDisplay = ({ exp, fontSize = "11px" }) => {
    if (!exp) return null;
    return (
      <Box sx={{ textAlign: "center", marginTop: "2px" }}>
        <Typography sx={{ color: "#e53935", fontSize, lineHeight: 1 }}>
          -{exp.amount}
        </Typography>
      </Box>
    );
  };

  const ExposureLabel = ({ value }) => {
    if (value === null || value === undefined || value === 0) return null;
    const isNegative = value < 0;
    return (
      <Typography
        sx={{
          fontSize: "10px",
          fontWeight: 600,
          color: isNegative ? "#ff4444" : "#00c853",
          textAlign: "center",
          lineHeight: 1,
          mt: "4px",
          mb: "2px",
          width: "100%",
          display: "block",
        }}
      >
        {value}
      </Typography>
    );
  };

  const getExposure = (selection) => {
    if (!selection) return null;
    const matched = casinoBets.filter(
      (b) => (b.selection || "").toUpperCase() === selection.toUpperCase(),
    );
    if (matched.length === 0) return null;

    const bet = matched[matched.length - 1];
    return {
      amount: parseFloat(bet.stake || 0),
    };
  };

  const handleNumberBoxClick = (
    value,
    label,
    positionIndex,
    buttonType,
    section,
    row,
  ) => {
    if (locked) return;

    let betType = "SIDE";
    let selection = "";

    if (section === "backlay") {
      betType = buttonType === "BlueButton" ? "BACK" : "LAY";
      selection = row.selections[positionIndex];
    } else if (section === "parity") {
      betType = "SIDE";
      selection = row.selections[positionIndex];
    }
    const betData = {
      userId: 357,
      roundId: socketData?.roundId,
      betType,
      selection,
      stake: 100,
      rate: parseFloat(value),
      odds: parseFloat(value),
      price: parseFloat(value),
      buttonType,
    };

    setSelectedBet(betData);
    setBetDialogOpen(true);

    if (onBetSelect) onBetSelect(betData);
  };

  const handleBetScreenClose = () => {
    setBetDialogOpen(false);
    setSelectedBet(null);
  };

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const playerKeyMap = {
    "Player 8": "ifPlayerA",
    "Player 9": "ifPlayerB",
    "Player 10": "ifPlayerC",
    "Player 11": "ifPlayerD",
  };

  const getExposureValue = (label, type) => {
    if (!exposureData) return null;
    const prefix = playerKeyMap[label];
    if (!prefix) return null;

    const keyMap = {
      wins: `${prefix}Wins`,
      odd: `${prefix}Odd`,
      even: `${prefix}Even`,
    };

    const val = exposureData[keyMap[type]];
    return val === undefined || val === null ? null : val;
  };

  return (

      <Box className={styles.MatchScreen_container}>
        <Box sx={{ position: "relative", width: "100%" }}>
          <GameScreen
            bettingClosed={socketData?.bettingClosed === true}
            animationTime={socketData?.animationTime}
            socketData={socketData}
            settledData={socketData?.settlement || settledData}
              onAnimStart={() => setAnimTimer(0)}
  onAnimEnd={() => setAnimTimer(null)}
   remainingTime={socketData?.remainingTime}
          />

         <Box className={styles.timer_container}>
  <Box
    className={styles.timer_wrapper}
    sx={{ position: "relative", minHeight: "60px" }}
  >
    <Box
      sx={{
        position: "absolute",
        bottom: "0px",
        right: "0px",
        zIndex: 99,
        pointerEvents: "none",
      }}
    >
      <FlipClock
        time={
          animTimer !== null
            ? animTimer
            : Number(socketData?.remainingTime) || 0
        }
      />
    </Box>
  </Box>
</Box>
        </Box>

        <Box className={styles.box1}>
          {/* Back & Lay Section */}
          <Box className={styles.box2}>
            <Box className={styles.RowHead}>
              <Box className={styles.InnerBox} />
              <Box className={styles.BlueBox}>
                <Typography className={styles.BoxText}>Back</Typography>
              </Box>
              <Box className={styles.RedBox}>
                <Typography className={styles.BoxText}>Lay</Typography>
              </Box>
            </Box>

            {FirstRows.map((row) => (
              <Box key={row.label} className={styles.RowBox}>
                <Box className={styles.InnerBox}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className={styles.RowText}>
                      {row.label}
                    </Typography>
                    <ExposureLabel
                      value={getExposureValue(row.label, "wins")}
                    />
                  </Box>
                </Box>
                {row.values.map((val, i) => (
                  <Box
                    key={i}
                    className={i === 0 ? styles.BlueButton : styles.RedButton}
                    onClick={() =>
                      handleNumberBoxClick(
                        val,
                        row.label,
                        i,
                        i === 0 ? "BlueButton" : "RedButton",
                        "backlay",
                        row,
                      )
                    }
                    sx={{
                      cursor: locked ? "not-allowed" : "pointer",
                      position: "relative",
                    }}
                  >
                    <Typography className={styles.NumberText}>{val}</Typography>

                    {locked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <path
                            d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                            fill="white"
                          />
                        </svg>
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            ))}
          </Box>

          {/* Odd / Even Section */}
          <Box className={styles.box2}>
            <Box className={styles.RowHead}>
              <Box className={styles.InnerBox} />
              <Box className={styles.BlueBoxx}>
                <Typography className={styles.BoxText}>Odd</Typography>
              </Box>
              <Box className={styles.BlueBoxx}>
                <Typography className={styles.BoxText}>Even</Typography>
              </Box>
            </Box>

            {SecondRows.map((row) => (
              <Box key={row.label} className={styles.RowBox}>
                <Box className={styles.InnerBox}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography className={styles.RowText}>
                      {row.label}
                    </Typography>
                   
                  </Box>
                </Box>
                {row.values.map((val, i) => (
                  <Box
                    key={i}
                    className={styles.BlueButton}
                    onClick={() =>
                      handleNumberBoxClick(
                        val,
                        row.label,
                        i,
                        "BlueButton",
                        "parity",
                        row,
                      )
                    }
                    sx={{
                      cursor: locked ? "not-allowed" : "pointer",
                      position: "relative",
                    }}
                  >
                    <Typography className={styles.NumberText}>{val}</Typography>
                 <ExposureLabel
      value={getExposureValue(row.label, i === 0 ? "odd" : "even")}
    />

                    {locked && (
                      <Box className={styles.bettinglocked_icon_container}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="20"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <path
                            d="M17.1969 9.53979C16.9582 9.30113 16.6686 9.18189 16.3275 9.18189H15.9187V6.72721C15.9187 5.15905 15.3563 3.81258 14.2313 2.68758C13.1063 1.56253 11.76 1 10.1916 1C8.62326 1 7.27665 1.56253 6.15178 2.68753C5.02673 3.81258 4.46439 5.15901 4.46439 6.72721V9.18189H4.05536C3.71456 9.18189 3.42472 9.30113 3.18607 9.53979C2.94741 9.77827 2.82812 10.0681 2.82812 10.4092V17.7728C2.82812 18.1136 2.94745 18.4035 3.18607 18.6422C3.42472 18.8806 3.71456 19 4.05536 19H16.3278C16.6689 19 16.9585 18.8808 17.1973 18.6422C17.4357 18.4035 17.5552 18.1136 17.5552 17.7728V10.4091C17.5554 10.0682 17.4357 9.77845 17.1969 9.53979ZM13.4643 9.18189H6.91894V6.72721C6.91894 5.82384 7.2386 5.05248 7.87778 4.41339C8.51705 3.77421 9.28828 3.45468 10.1917 3.45468C11.0953 3.45468 11.8663 3.77416 12.5056 4.41339C13.1446 5.05244 13.4643 5.82384 13.4643 6.72721V9.18189Z"
                            fill="white"
                          />
                        </svg>
                      </Box>
                    )}

                    <ExpDisplay
                      exp={getExposure(row.selections[i])}
                      fontSize="11px"
                    />
                  </Box>
                ))}
              </Box>
            ))}
          </Box>

          <FooterLinks
            gameType="card32"
            socketData={socketData}
            settledData={settledData}
          />
        </Box>
      </Box>
   
  );
}

export default Card32;
